/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener("DOMContentLoaded", function () {
  var buyNowButton = document.getElementById("BuyNowButton");
  if (buyNowButton) {
    buyNowButton.addEventListener("click", function (e) {
      e.preventDefault();

      // Encontra o formulário do produto
      var productForm = buyNowButton.closest('form[action*="/cart/add"]');
      if (!productForm) {
        productForm = document.querySelector('form[action*="/cart/add"]');
      }

      if (!productForm) {
        console.error('Formulário do produto não encontrado');
        return;
      }

      // Desabilita o botão para evitar cliques múltiplos
      buyNowButton.disabled = true;
      var originalText = buyNowButton.textContent;
      buyNowButton.textContent = 'Processando...';

      // Coleta os dados do formulário
      var formData = new FormData(productForm);

      // Adiciona o produto ao carrinho via AJAX
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
        .then(response => response.json())
        .then(data => {
          // Produto adicionado com sucesso, redireciona para o checkout
          window.location.href = '/checkout';
        })
        .catch(error => {
          console.error('Erro ao adicionar produto ao carrinho:', error);
          // Restaura o botão em caso de erro
          buyNowButton.disabled = false;
          buyNowButton.textContent = originalText;
          alert('Erro ao adicionar produto ao carrinho. Por favor, tente novamente.');
        });
    });
  }
});


document.addEventListener("DOMContentLoaded", function () {
  var lastScrollTop = 0;
  var scrollThreshold = 100; // Aumentei o threshold para evitar mudanças muito sensíveis
  var currentDirection = null; // Variável para rastrear a direção atual

  function handleScroll() {
    var currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var menuElements = document.querySelectorAll('[data-menu="scroll"]');

    if (menuElements.length === 0) return;

    // Só muda a direção se a diferença for significativa
    var scrollDifference = Math.abs(currentScrollTop - lastScrollTop);

    if (scrollDifference > scrollThreshold) {
      var newDirection = currentScrollTop > lastScrollTop ? 'down' : 'up';

      // Só aplica mudança se a direção realmente mudou
      if (newDirection !== currentDirection) {
        currentDirection = newDirection;

        menuElements.forEach(function (element) {
          if (currentDirection === 'down') {
            element.classList.remove('scrolled-up');
            element.classList.add('scrolled-down');
          } else {
            element.classList.remove('scrolled-down');
            element.classList.add('scrolled-up');
          }
        });
      }

      lastScrollTop = currentScrollTop;
    }
  }

  // Adiciona o listener de scroll com throttling para melhor performance
  var ticking = false;
  function requestTick() {
    if (!ticking) {
      requestAnimationFrame(function () {
        handleScroll();
        ticking = false;
      });
      ticking = true;
    }
  }

  // Listener sempre ativo independentemente do tamanho de tela
  window.addEventListener('scroll', requestTick, { passive: true });

  // Executa uma vez no carregamento para definir o estado inicial
  handleScroll();
});


// Evento para remover a classe is-fixed quando clicar fora da barra de busca
document.addEventListener("DOMContentLoaded", function () {
  // Função para remover is-fixed e limpar estilos
  function removeIsFixed(searchBar, unfixButton) {
    searchBar.classList.remove('is-fixed');
    document.body.classList.remove('no-mobile-scroll');
    if (unfixButton) unfixButton.style.width = '';

    const results = searchBar.querySelector('.search-bar__results');
    if (results) results.setAttribute('aria-hidden', 'true');
  }

  // Função para inicializar a funcionalidade
  function initSearchBarFunctionality() {
    const searchBar = document.getElementById('header-search-bar');
    const toggleButton = document.querySelector('[data-action="toggle-search"]');
    const searchBg = document.querySelector('.header__search-background');
    const unfixButton = document.querySelector('[data-action="unfix-search"]');

    if (!searchBar || searchBar.hasAttribute('data-custom-initialized')) return;

    searchBar.setAttribute('data-custom-initialized', 'true');

    // Clique fora da barra de busca
    document.addEventListener('click', function (event) {
      if (!searchBar.contains(event.target) && event.target !== toggleButton && !toggleButton.contains(event.target)) {
        removeIsFixed(searchBar, unfixButton);
      }
    });

    // Previne propagação de cliques dentro da barra
    searchBar.addEventListener('click', event => event.stopPropagation());

    // Clique no fundo da barra
    if (searchBg && !searchBg.hasAttribute('data-custom-initialized')) {
      searchBg.setAttribute('data-custom-initialized', 'true');
      searchBg.addEventListener('click', function (event) {
        removeIsFixed(searchBar, unfixButton);
        event.stopPropagation();
      });
    }

    // Toggle mobile
    if (toggleButton && !toggleButton.hasAttribute('data-custom-initialized')) {
      toggleButton.setAttribute('data-custom-initialized', 'true');
      toggleButton.addEventListener('click', function (event) {
        event.preventDefault();

        const isVisible = searchBar.classList.contains('is-visible') || searchBar.style.display === 'block';

        if (isVisible) {
          searchBar.classList.remove('is-visible');
          searchBar.style.display = 'none';
          removeIsFixed(searchBar, unfixButton);
        } else {
          searchBar.classList.add('is-visible');
          searchBar.style.display = 'block';
          searchBar.classList.add('is-fixed');
          document.body.classList.add('no-mobile-scroll');

          const searchInput = searchBar.querySelector('.search-bar__input');
          if (searchInput) setTimeout(() => searchInput.focus(), 100);
        }
      });
    }
  }

  // Inicializações múltiplas para garantir carregamento
  [0, 100, 500].forEach(delay => setTimeout(initSearchBarFunctionality, delay));
  window.addEventListener('load', initSearchBarFunctionality);

  // Observer para mudanças no DOM
  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(() => initSearchBarFunctionality())
      .observe(document.body, { childList: true, subtree: true });
  }
});

// Controle de quantidade limitada ao estoque disponível
document.addEventListener("DOMContentLoaded", function () {
  function initQuantityControl() {
    const quantitySelector = document.querySelector('.quantity-selector--product');
    if (!quantitySelector) return;

    const quantityInput = quantitySelector.querySelector('.quantity-selector__value');
    const increaseBtn = quantitySelector.querySelector('[data-action="increase-picker-quantity"]');
    const decreaseBtn = quantitySelector.querySelector('[data-action="decrease-picker-quantity"]');

    if (!quantityInput) return;

    // Marca como inicializado para evitar duplicação
    if (quantityInput.hasAttribute('data-quantity-control-initialized')) return;
    quantityInput.setAttribute('data-quantity-control-initialized', 'true');

    // Função para obter o limite máximo
    function getMaxQuantity() {
      const maxPerOrder = 50; // Limite máximo por pedido
      const maxAttr = quantityInput.getAttribute('max');

      if (!maxAttr || maxAttr === '') return maxPerOrder;

      const maxValue = parseInt(maxAttr);
      if (isNaN(maxValue)) return maxPerOrder;

      // Retorna o menor valor entre o estoque disponível e 50 unidades
      return Math.min(maxValue, maxPerOrder);
    }

    // Função para validar e ajustar a quantidade
    function validateQuantity() {
      const maxQuantity = getMaxQuantity();
      let currentValue = parseInt(quantityInput.value) || 1;

      // Garante que o valor está dentro dos limites
      if (currentValue < 1) currentValue = 1;
      if (currentValue > maxQuantity) {
        currentValue = maxQuantity;
        // Mostra feedback visual quando atingir o limite
        quantityInput.style.borderColor = '#ff0000';
        setTimeout(() => {
          quantityInput.style.borderColor = '';
        }, 500);
      }

      quantityInput.value = currentValue;

      // Atualiza o estado do botão de aumentar
      updateIncreaseButton(currentValue, maxQuantity);

      return currentValue;
    }

    // Função para atualizar o estado do botão de aumentar
    function updateIncreaseButton(currentValue, maxQuantity) {
      if (!increaseBtn) return;

      if (currentValue >= maxQuantity) {
        increaseBtn.setAttribute('disabled', 'disabled');
        increaseBtn.setAttribute('aria-label', 'Limite máximo atingido');
        increaseBtn.setAttribute('title', 'Limite máximo atingido (máx: ' + maxQuantity + ' unidades)');
        increaseBtn.style.opacity = '0.5';
        increaseBtn.style.cursor = 'not-allowed';
      } else {
        increaseBtn.removeAttribute('disabled');
        increaseBtn.style.opacity = '';
        increaseBtn.style.cursor = '';
        const originalLabel = increaseBtn.getAttribute('data-original-label');
        const originalTitle = increaseBtn.getAttribute('data-original-title');
        if (originalLabel) increaseBtn.setAttribute('aria-label', originalLabel);
        if (originalTitle) increaseBtn.setAttribute('title', originalTitle);
      }
    }

    // Salva os labels originais
    if (increaseBtn) {
      increaseBtn.setAttribute('data-original-label', increaseBtn.getAttribute('aria-label'));
      increaseBtn.setAttribute('data-original-title', increaseBtn.getAttribute('title'));
    }

    // Evento de aumentar quantidade
    if (increaseBtn) {
      // Remove listeners antigos se existirem
      const newIncreaseBtn = increaseBtn.cloneNode(true);
      increaseBtn.parentNode.replaceChild(newIncreaseBtn, increaseBtn);

      newIncreaseBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const maxQuantity = getMaxQuantity();
        let currentValue = parseInt(quantityInput.value) || 1;

        // Só aumenta se estiver abaixo do limite
        if (currentValue < maxQuantity) {
          quantityInput.value = currentValue + 1;
          updateIncreaseButton(currentValue + 1, maxQuantity);
        } else {
          // Mostra feedback visual quando atingir o limite
          quantityInput.style.borderColor = '#ff0000';
          setTimeout(() => {
            quantityInput.style.borderColor = '';
          }, 500);
        }
      });
    }

    // Evento de diminuir quantidade
    if (decreaseBtn) {
      // Remove listeners antigos se existirem
      const newDecreaseBtn = decreaseBtn.cloneNode(true);
      decreaseBtn.parentNode.replaceChild(newDecreaseBtn, decreaseBtn);

      newDecreaseBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        let currentValue = parseInt(quantityInput.value) || 1;

        if (currentValue > 1) {
          quantityInput.value = currentValue - 1;
          updateIncreaseButton(currentValue - 1, getMaxQuantity());
        }
      });
    }

    // Previne entrada de caracteres não numéricos
    quantityInput.addEventListener('keydown', function (e) {
      // Permite: backspace, delete, tab, escape, enter
      if ([46, 8, 9, 27, 13].indexOf(e.keyCode) !== -1 ||
        // Permite: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
        (e.keyCode === 65 && e.ctrlKey === true) ||
        (e.keyCode === 67 && e.ctrlKey === true) ||
        (e.keyCode === 86 && e.ctrlKey === true) ||
        (e.keyCode === 88 && e.ctrlKey === true) ||
        // Permite: home, end, left, right
        (e.keyCode >= 35 && e.keyCode <= 39)) {
        return;
      }
      // Garante que é um número
      if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
        e.preventDefault();
      }
    });

    // Valida quando o usuário digita manualmente ou cola
    quantityInput.addEventListener('input', function () {
      // Remove caracteres não numéricos
      let cleanValue = this.value.replace(/[^0-9]/g, '');

      // Se o valor limpo for diferente, atualiza
      if (cleanValue !== this.value) {
        this.value = cleanValue;
      }

      // Valida o valor em tempo real
      const maxQuantity = getMaxQuantity();
      let currentValue = parseInt(this.value) || 0;
      if (currentValue > maxQuantity) {
        this.value = maxQuantity;
        // Mostra feedback visual
        this.style.borderColor = '#ff0000';
        setTimeout(() => {
          this.style.borderColor = '';
        }, 500);
      }

      // Atualiza o botão de aumentar
      updateIncreaseButton(parseInt(this.value) || 1, maxQuantity);
    });

    quantityInput.addEventListener('change', function () {
      validateQuantity();
    });

    quantityInput.addEventListener('blur', function () {
      validateQuantity();
    });

    // Valida quando a variante muda
    document.addEventListener('variant:changed', function (event) {
      const variant = event.detail.variant;

      if (variant && variant.inventory_management && variant.inventory_policy === 'deny') {
        quantityInput.setAttribute('max', variant.inventory_quantity);
        quantityInput.setAttribute('data-inventory-quantity', variant.inventory_quantity);
      } else {
        quantityInput.removeAttribute('max');
        quantityInput.removeAttribute('data-inventory-quantity');
      }

      // Reseta para 1 e valida
      quantityInput.value = 1;
      validateQuantity();
    });

    // Validação inicial
    validateQuantity();
  }

  // Inicializa o controle de quantidade
  initQuantityControl();

  // Reinicializa quando o DOM muda (para temas dinâmicos)
  if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.addedNodes.length) {
          initQuantityControl();
        }
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }
});

